import { Injectable } from "@angular/core";
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ShellSideNavService {
  private closeSideNavSource = new Subject<boolean>();
  public closeSideNav$ = this.closeSideNavSource.asObservable();

  CloseSideNav(force: boolean = false) {
    this.closeSideNavSource.next(force);
  }

}
